export default "/images/Jean-YvesLamarque.jpg?004732f88d7ebc90fa9bcaea11950805";